<template>
  <div class="product-match section">
    <div v-if="finishedLoadingProductMacth" class="header-section">
      <h2 class="section-heading">{{ sectionTitle }}</h2>
    </div>
    <template v-if="!isLogin">
      <div class="product-section__action">
        <p class="product-section__action__text-nologin show-desktop">
          Login / Register untuk mendapatkan produk yang lebih relevan dengan beauty profile kamu.
          <strong class="bold-button" @click="openLoginOtf()">Login Sekarang</strong>
        </p>
      </div>
    </template>
    <template v-else>
      <!-- BP & My Interest hidden on web: https://new-sociolla.atlassian.net/browse/NON-16072 -->
      <template>
        <div v-if="!finishedLoadingProductMacth" :style="{ paddingBottom: '16px' }">
          <ListProductSlideLoader />
        </div>
        <ListProductSlide
          v-else-if="productMatchMobile.length || $store.state.product.productMatch.length"
          key="trendingProducts"
          :products="isDesktop ? $store.state.product.productMatch : productMatchMobile"
          :is-loading-finish="finishedLoadingProductMacth"
          :per-page-custom-props="isDesktop ? 6 : 3"
          section="product_match"
          @get-products="checkSkip()"
        />
      </template>
    </template>
  </div>
</template>
<script>
import Auth from '@/shared/auth';
export default {
  name: 'product-match',
  components: {
    ListProductSlide: () => import('@/components/dashboard/snippet/list-product-slide'),
    ListProductSlideLoader: () => import('@/components/global/loader/list-product-slide-loader'),
  },
  data() {
    return {
      productMatch: [],
      productMatchMobile: [],
      finishedLoadingProductMacth: false,
      limit: 10,
      skip: 0,
      sectionTitle: 'You Might Love These',
    };
  },
  computed: {
    screen() {
      return this.$store.state.screen;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    isLogin() {
      return this.$SO.size(this.$store.state.auth.userProfile);
    },
    user() {
      return this.$store.state.auth.userProfile;
    },
    notCompletedBeautyProfile() {
      if (this.isLogin) {
        return !Boolean(this.user.beauty && this.user.beauty.length);
      }
      return true;
    },
    notCompletedDetailProfile() {
      if (this.isLogin) {
        return !Boolean(
          this.user.hasOwnProperty('birthday_date') && this.user.hasOwnProperty('country') && this.user.country.name
        );
      }
      return true;
    },
  },
  watch: {
    isLogin(newLogin) {
      if (newLogin && this.isDesktop) {
        this.getProducts();
      }
    },
  },
  mounted() {
    if (this.$store.state.screen.isDesktop) {
      this.getProducts();
    } else {
      this.getProductsMobile();
    }
  },
  methods: {
    openLoginOtf() {
      Auth.CentralAuth.login();
    },
    completeBeautyProfile() {
      this.$router.push(this.notCompletedDetailProfile ? '/register-detail' : '/beauty-profile');
    },
    toproductMatch() {
      if (this.isLogin) {
        // BP & My Interest hidden on web: https://new-sociolla.atlassian.net/browse/NON-16072
        this.$router.push('/our-curated-selection');
      } else {
        this.$store.commit('modalAuth', 1);
      }
    },
    checkSkip() {
      this.skip = this.skip + this.$store.state.product.productMatch.length;
      if (this.$store.state.product.productMatch.length < 10) {
        this.getProducts();
      } else {
        return;
      }
    },
    getProducts() {
      if (!this.notCompletedBeautyProfile) {
        const tags = [];
        this.user.beauty.forEach((item) => {
          item.subtags.forEach((item2) => tags.push(item2.name));
        });
        Promise.all([
          this.$MS_SOCO_PUBLIC_API_URL.get(`/products/featured/you-might-love-these`, {
            params: {
              filter: {
                is_in_stock: true,
                is_reviewed: true,
                is_active_in_review: true,
                is_you_might_love: true,
                trim_response: true,
                'tags.name': {
                  $in: tags,
                },
              },
              skip: this.skip,
              limit: this.limit,
            },
          }),
          this.$MS_SOCO_PUBLIC_API_URL.get('/products/featured/you-might-love-these/title'),
        ])
          .then(([response, titleResponse]) => {
            if (response.status === 200) {
              const response_data = response.data.data;
              // this.productMatch = response.data.data;
              if (this.$store.state.product.productMatch && this.$store.state.product.productMatch.length) {
                this.$store.commit('product_match', { data: response_data, merge: true });
              } else {
                this.$store.commit('product_match', { data: response_data });
              }
            } else {
              // this.productMatch = [];
              this.$store.commit('product_match', { data: [] });
            }
            if (titleResponse.status === 200 && titleResponse.data && titleResponse.data.data) {
              this.sectionTitle = titleResponse.data.data;
            }
            this.finishedLoadingProductMacth = true;
          })
          .catch((err) => {
            this.finishedLoadingProductMacth = true;
            this.productMatch = [];
          });
      } else {
        // this.productMatch = [];
        this.$store.commit('product_match', { data: [] });
        this.finishedLoadingProductMacth = true;
      }
    },
    getProductsMobile() {
      if (!this.notCompletedBeautyProfile) {
        const tags = [];
        this.user.beauty.forEach((item) => {
          item.subtags.forEach((item2) => tags.push(item2.name));
        });
        Promise.all([
          this.$MS_SOCO_PUBLIC_API_URL.get(`/products/featured/you-might-love-these`, {
            params: {
              filter: {
                is_in_stock: true,
                is_out_of_stock_sociolla: false,
                is_reviewed: true,
                is_active_in_review: true,
                is_active_in_sociolla: true,
                is_you_might_love: true,
                trim_response: true,
                'tags.name': {
                  $in: tags,
                },
              },
              skip: 0,
              limit: 10,
            },
          }),
          this.$MS_SOCO_PUBLIC_API_URL.get('/products/featured/you-might-love-these/title'),
        ])
          .then(([response, titleResponse]) => {
            if (response.status === 200) {
              this.productMatchMobile = response.data.data;
            } else {
              this.productMatchMobile = [];
            }
            if (titleResponse.status === 200 && titleResponse.data && titleResponse.data.data) {
              this.sectionTitle = titleResponse.data.data;
            }
            this.finishedLoadingProductMacth = true;
          })
          .catch((err) => {
            this.finishedLoadingProductMacth = true;
            this.productMatchMobile = [];
          });
      } else {
        this.productMatchMobile = [];
        this.finishedLoadingProductMacth = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';
.show-desktop {
  display: block;
}

.show-mobile {
  display: none;
}
.product-match {
  padding: 16px 24px 2px;
  margin-bottom: 24px;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.18);
  @media (max-width: 991px) {
    padding: 16px 24px;
  }
  .header-section {
    display: flex;
    flex-wrap: wrap;
    & > img {
      margin-right: 16px;
    }
  }
  .header-section-title {
    width: 100%;
    position: relative;
    & > h2 {
      font: 16px/22px $lato_bold;
      color: #231f20;
      margin: 0;
    }
    & > p {
      font: normal 12px/18px $lato_regular;
      margin: 0;
      color: $greynew;
      margin-top: 8px;
      margin-bottom: 10px;
      a {
        color: $red;
        font-family: $lato_bold;
      }
    }
    .info-bar__show-all {
      position: absolute;
      right: -25px;
      top: 0;
    }
  }
  .product-section__action {
    background-color: #ffe2eb;
    background-image: url(/assets/img/love_these_icon.svg);
    background-position: top right;
    background-size: auto;
    background-repeat: no-repeat;
    width: 100%;
    border-radius: 4px;
    padding: 0;
    margin-bottom: 16px;
    position: relative;
    height: 50px;
    padding: 16px;
    height: auto;
    display: flex;
    align-items: center;
    .product-section__action__text {
      font: 14px/18px $lato_regular;
      color: #231f20;
      margin: 0 !important;
      display: flex;
      justify-content: space-between;
      text-align: left;
      width: 100%;
      padding: 0 16px;
      &-nologin {
        font: 14px/18px 'lato-regular', sans-serif;
        display: block;
        text-align: center;
        margin-bottom: 5px;
        @media (max-width: 991px) {
          font-size: 10px;
          margin-bottom: 5px;
        }
        .bold-button {
          color: #eb395f;
        }
      }
      h4 {
        font: 16px/22px $lato_bold;
        color: $vividpink;
        margin: 0;
        margin-bottom: 2px;
      }
      p {
        font: 'lato-regular', sans-serif;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        margin: 10px 0px 0px;
        strong {
          font-family: $lato_bold;
          font-size: 12px;
          font-weight: 700;
          line-height: 18px;
        }
      }
      .action-new {
        padding: 9px 16.5px;
        font-size: 14px;
        font: 14px/18px $lato_bold;
      }
    }
    .action {
      height: auto;
      padding: 5px 16.5px;
      font-size: 14px;
      font: 14px/18px $lato_bold;
      width: 165px;
      margin: 5px auto 0;
    }
    &.centered {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      flex-direction: column;
    }
    // &::after {
    //   content: '';
    //   background-image: url(/assets/img/complete-bp-illustration.svg);
    //   position: absolute;
    //   right: 0;
    //   border: 0;
    //   height: 100%;
    //   width: 100%;
    //   background-position: bottom right;
    //   background-repeat: no-repeat;
    //   background-size: auto;
    //   bottom: 0;
    // }
  }
  .product-section {
    margin-top: 20px;
    ::v-deep .list-product-slide {
      padding-left: 0px;
    }
  }
  .bolder {
    font: 12px/20px $lato_bold;
  }
  @media (max-width: 991px) {
    background-color: #fff;
    padding: 16px 0px 16px 16px;
    margin-bottom: 0px;
    box-shadow: none;
    .header-section-title {
      .info-bar__show-all {
        top: 0px;
      }
    }
    .product-section {
      margin-top: 0;
    }
    .product-section__action {
      padding: 12px 18px;
      position: relative;
      margin-bottom: 0;
      .product-section__action__text {
        font: 12px/20px $lato_medium;
        z-index: 1;
        position: relative;
        padding: 0;
        h4 {
          margin: 0;
          font: 14px/22px $lato_bold;
          color: $vividpink;
        }
        .action-new {
          position: absolute;
          display: block;
          opacity: 1;
          height: 24px;
          border-radius: 4px;
          font-size: 10px;
          letter-spacing: 1px;
          line-height: 5px;
          right: 2px;
        }
        a.action {
          padding: 2.5px 9px;
          margin: 0;
          font: 10px/15px $lato_bold;
          min-width: unset;
        }
        > p {
          text-align: left;
          margin: 0;
        }
      }
      .action {
        margin-bottom: 16px;
      }
    }
    &::v-deep .list-scrollable {
      padding: 0;
    }
  }
}
@media (max-width: 991px) {
  .show-desktop {
    display: none;
  }

  .show-mobile {
    display: block;
  }
}
</style>
